import { useState } from "react";
import { Button, Field, Input, Modal } from "../../shared/ui/index.js";
import { useConvertLead, type Lead } from "./leads.api.js";

export function ConvertLeadDialog({ lead, onClose }: { lead: Lead; onClose: () => void }) {
  const convert = useConvertLead(lead.id);
  const [name, setName] = useState(lead.contactName);
  const [mode, setMode] = useState<"password" | "invite">("invite");
  const [password, setPassword] = useState("");

  return (
    <Modal title="Convertir en client" onClose={onClose}>
      {convert.data ? (
        <div className="flex flex-col gap-3 text-sm">
          <p className="text-emerald-700">Compte créé pour {lead.email}.</p>
          {convert.data.inviteUrl && (
            <>
              <p className="text-stone-600">Lien d'invitation à transmettre :</p>
              <code className="block break-all rounded bg-stone-100 p-2 text-xs">
                {convert.data.inviteUrl}
              </code>
            </>
          )}
          <Button onClick={onClose}>Fermer</Button>
        </div>
      ) : (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            convert.mutate({
              name,
              email: lead.email,
              mode,
              password: mode === "password" ? password : undefined,
            });
          }}
          className="flex flex-col gap-3"
        >
          <Field label="Nom du client">
            <Input value={name} onChange={(e) => setName(e.target.value)} required />
          </Field>
          <Field label="Email">
            <Input value={lead.email} disabled />
          </Field>
          <ModePicker mode={mode} onChange={setMode} />
          {mode === "password" && (
            <Field label="Mot de passe (8 car. min.)">
              <Input
                type="text"
                minLength={8}
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Field>
          )}
          {convert.isError && <p className="text-sm text-rose-600">Échec.</p>}
          <Button type="submit" disabled={convert.isPending}>
            Créer le compte
          </Button>
        </form>
      )}
    </Modal>
  );
}

export function ModePicker({
  mode,
  onChange,
}: {
  mode: "password" | "invite";
  onChange: (m: "password" | "invite") => void;
}) {
  return (
    <div className="flex gap-4 text-sm">
      <label className="flex items-center gap-1">
        <input type="radio" checked={mode === "invite"} onChange={() => onChange("invite")} />
        Lien d'invitation
      </label>
      <label className="flex items-center gap-1">
        <input type="radio" checked={mode === "password"} onChange={() => onChange("password")} />
        Mot de passe
      </label>
    </div>
  );
}
